import React, { use } from 'react'
import { useState, useEffect } from 'react'
import { CiFilter } from "react-icons/ci";
import { FaFilter } from 'react-icons/fa';
import CargoModal from './modal/CardCargo';
import Footer from '../../../components/Footer';
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { motion, AnimatePresence } from 'framer-motion';
import CargoService from '../../../services/Cargo';
import FilterModal from './modal/FilterModal';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
// import { showToast } from '../../redux/slices/toastSlice';
import EmptyStateMyLoads from '../../../Modals/empty list/EmptyList';
import AllCargoSkeleton from './modal/AllCargoSkeleton';

const DriverCargo = () => {

    const dispatch = useDispatch()
    const [openFilter, setOpenFilter] = useState(false)

    const [allCity, setAllCity] = useState([])
    const [searchCity, setSearchCity] = useState("")

    const [allState, setAllState] = useState([])
    const [searchState, setSearchState] = useState("")

    const [allCarType, setAllCarType] = useState([])
    const [searchCarType, setSearchCarType] = useState("")

    const [allCargoProduct, setAllCargoProduct] = useState([])
    const [searchCargoProduct, setSearchCargoProduct] = useState("")

    const [falgOrigin, setFlagOrigin] = useState("state")
    const [flagDest, setFlagDest] = useState("state")


    const [originStateId, setOriginStateId] = useState(null);
    const [destStateId, setDestStateId] = useState(null);

    //searches
    // const [searchOrigin, setSearchOrigin] = useState("");
    // const [searchDest, setSearchDest] = useState("");
    // const [searchCargo, setSearchCargo] = useState("");
    // const [searchCar, setSearchCar] = useState("");
    const [search, setSearch] = useState("")


    const toggleRef = useRef(null);


    async function fetchCitiesForState(state_id, search = "") {
        try {
            const res = await CargoService.getAllCity({ search, state_id });
            const data = res?.data?.data || [];

            return data;
        } catch (err) {

            return [];
        }
    }

    useEffect(() => {

        fetchCitiesForState(originStateId, searchCity);

    }, [originStateId, searchCity]);


    useEffect(() => {

        fetchCitiesForState(destStateId, searchCity);

    }, [destStateId, searchCity]);



    //state
    async function getAllState() {
        try {

            const res = await CargoService.getAllState()
            setAllState(res?.data?.data)


        } catch (err) {
            console.log(err)
        }
    }


    useEffect(() => {
        getAllState()
    }, [])



    //cargo

    async function getAllCargoPro() {
        try {
            const search = {
                search: searchCargoProduct
            }
            const res = await CargoService.getAllProductType(search)
            setAllCargoProduct(res?.data?.data)


        } catch (err) {
            console.log(err)
        }
    }
    useEffect(() => {
        getAllCargoPro()
    }, [searchCargoProduct])


    //car

    async function getAllCar() {
        try {
            const search = {
                search: searchCarType
            }
            const res = await CargoService.getAllCarType(search)
            setAllCarType(res?.data?.data)


        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getAllCar()
    }, [searchCarType])


    // origin state
    useEffect(() => {
        if (falgOrigin === "state") {
            setFilterItems(prev =>
                prev.map((item, idx) =>
                    idx === 0
                        ? { ...item, sub: allState }
                        : item
                )
            )
        }


    }, [falgOrigin, allState])


    // dest
    useEffect(() => {

        if (flagDest === "state") {
            setFilterItems(prev =>
                prev.map((item, idx) =>
                    idx === 1
                        ? { ...item, sub: allState }
                        : item
                )
            )
        }
    }, [flagDest, allState])


    //car
    useEffect(() => {


        setFilterItems(prev =>
            prev.map((item, idx) =>
                idx === 3
                    ? { ...item, sub: allCarType }
                    : item
            )
        )

    }, [allCarType])

    //cargoProduct

    useEffect(() => {


        setFilterItems(prev =>
            prev.map((item, idx) =>
                idx === 2
                    ? { ...item, sub: allCargoProduct }
                    : item
            )
        )

    }, [allCargoProduct])


    const CargoRecent = [
        {
            _id: "asdfasdafsadfdsf",
            typeOfCar: "تریلی بغلدار",
            timeOfCargo: "دوشنبه",
            timeOfCreate: "۳ ساعت پیش",
            origin: "اصفهان",
            dest: "تهران"
        },
        {
            _id: "asdfasdafsadfdsj",
            typeOfCar: "تریلی بغلدار",
            timeOfCargo: "سه شنبه",
            timeOfCreate: "۴ ساعت پیش",
            origin: "اصفهان",
            dest: "بندر عباس"
        },
        {
            _id: "asdfasdafsadfdss",
            typeOfCar: "تریلی بغلدار",
            timeOfCargo: "پنجشنبه",
            timeOfCreate: "۱۲ ساعت پیش",
            origin: "بندر عباس",
            dest: "تهران"
        },
        {
            _id: "asdfasdafsadfdsd",
            typeOfCar: "تریلی بغلدار",
            timeOfCargo: "پنجشنبه",
            timeOfCreate: "۱۲ ساعت پیش",
            origin: "بندر عباس",
            dest: "تهران"
        },
        {
            _id: "asdfasdafsadfdse",
            typeOfCar: "تریلی بغلدار",
            timeOfCargo: "پنجشنبه",
            timeOfCreate: "۱۲ ساعت پیش",
            origin: "بندر عباس",
            dest: "تهران"
        },
        {
            typeOfCar: "تریلی بغلدار",
            timeOfCargo: "پنجشنبه",
            timeOfCreate: "۱۲ ساعت پیش",
            origin: "بندر عباس",
            dest: "تهران"
        },
        {
            typeOfCar: "تریلی بغلدار",
            timeOfCargo: "پنجشنبه",
            timeOfCreate: "۱۲ ساعت پیش",
            origin: "بندر عباس",
            dest: "تهران"
        },

        {
            typeOfCar: "تریلی بغلدار",
            timeOfCargo: "پنجشنبه",
            timeOfCreate: "۱۲ ساعت پیش",
            origin: "بندر عباس",
            dest: "تهران"
        },


    ]

    const [filterItems, setFilterItems] = useState([
        { main: "مبدا", sub: [], enable: false, hasSearch: true },
        { main: "مقصد", sub: [], enable: false, hasSearch: true },
        { main: "نوع بار", sub: [], enable: false, hasSearch: true },
        { main: "نوع خودرو", sub: [], enable: false, hasSearch: true },
        { main: "نوع بار", sub: [{ name: "داخلی", _id: "domestic" }, { name: "خارجی", _id: "international" }], enable: false }
    ]);

    useEffect(() => {

        if (falgOrigin == "state") {
            setFilterItems(prev =>
                prev.map((item, idx) =>
                    idx === 0
                        ? {
                            ...item,
                            sub: allState,

                        }
                        : item
                )
            );
        }

    }, [allState])


    async function handleOnOptionClick(main, subItem, index) {

        if (main === "مبدا") {

            if (falgOrigin === "state") {

                try {
                    const cities = await fetchCitiesForState(subItem._id, "");
                    setOriginStateId(subItem._id);
                    setFlagOrigin("city");

                    setFilterItems(prev =>
                        prev.map((item, idx) =>
                            idx === index
                                ? {
                                    ...item,
                                    sub: cities,
                                    selected: `${subItem.name}`,
                                    selectedVal: { state: subItem._id, city: null },
                                    enable: true
                                }
                                : item
                        )
                    );

                } catch (err) {

                }

                setSearchState("")
                return
            } else {

                setFilterItems(prev =>
                    prev.map((item, idx) =>
                        idx === index
                            ? {
                                ...item,
                                selected: `${item.selected} , ${subItem.name}`,
                                selectedVal: { state: subItem.state_id ?? originStateId, city: subItem._id },
                                enable: false
                            }
                            : item
                    )
                );
                setFlagOrigin("state");
                setSearchCity("")

            }
            return;
        }


        if (main === "مقصد") {
            if (flagDest === "state") {
                try {

                    const cities = await fetchCitiesForState(subItem._id, searchCity);
                    setDestStateId(subItem._id);
                    setFlagDest("city");

                    setFilterItems(prev =>
                        prev.map((item, idx) =>
                            idx === index
                                ? {
                                    ...item,
                                    sub: cities,
                                    selected: `${subItem.name}`,
                                    selectedVal: { state: subItem._id, city: null },
                                    enable: true
                                }
                                : item
                        )
                    );


                } catch (err) {

                }


                return
            } else {



                setFilterItems(prev =>
                    prev.map((item, idx) =>
                        idx === index
                            ? {
                                ...item,
                                selected: `${item.selected} , ${subItem.name}`,
                                selectedVal: { state: subItem.state_id ?? destStateId, city: subItem._id },
                                enable: false
                            }
                            : item
                    )
                );
                setFlagDest("state");
                setSearchCity("")

            }
            return;
        }

        if (main === "نوع بار") {

            setFilterItems(prev =>
                prev.map((item, idx) =>
                    idx === index
                        ? {
                            ...item,
                            sub: allCargoProduct,
                            selected: `${subItem.name}`,
                            selectedVal: subItem._id,
                            enable: false
                        }
                        : item
                )
            );
            setSearchCargoProduct("")
            return
        }
        if (main === "نوع خودرو") {

            setFilterItems(prev =>
                prev.map((item, idx) =>
                    idx === index
                        ? {
                            ...item,
                            sub: allCarType,
                            selected: `${subItem.name}`,
                            selectedVal: subItem._id,
                            enable: false
                        }
                        : item
                )
            );
            setSearchCarType("")
            return
        }



    }

    async function handleSearchToggle(search, index) {
        setFilterItems((prev) =>
            prev.map((item, idx) => {
                if (idx !== index) return item;

                const originalSub = item.subOriginal || item.sub;

                const filteredSub = search
                    ? originalSub.filter((subItem) =>
                        subItem.name.toLowerCase().includes(search.toLowerCase())
                    )
                    : originalSub;

                const shouldExpand =
                    filteredSub.length > 0 && !(search && search.trim().length > 0);

                return {
                    ...item,
                    sub: filteredSub,
                    subOriginal: originalSub,
                    expanded: shouldExpand ? idx : null,
                };
            })
        );



    }
    const [loading, setLoading] = useState(true)

    //get all cargos
    async function getAllCargo() {
        setLoading(true);
        try {

            const param = {
                // pagination:true,
                // page:1,
                // limit:400,
                origin: filterItems[0].selectedVal?.city,
                destination: filterItems[1].selectedVal?.city,
                product: filterItems[2].selectedVal,
                car: filterItems[3].selectedVal,
                type: filterItems[4].selectedVal
            }
            console.log(param)

            const res = await CargoService.getAllCargo(param)
            setAllCarogs(res?.data?.data)


        } catch (err) {

            console.log(err)
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getAllCargo()
    }, [filterItems])


    const [allCargos, setAllCarogs] = useState([])
    const navigate = useNavigate()

    // console.log(filterItems)

    if (loading) {
        return (
            <div className="w-full flex flex-col gap-10 min-h-screen  py-10 lg:px-10 px-5">

                {/* header */}
                <div className='flex relative justify-between w-full h-auto mt-36 items-center'>
                    <AllCargoSkeleton />
                </div>
            </div>

        )
    }
    return (
        <>
        {
             allCargos?.length == 0 ?
             <>
             <div className="flex flex-col min-h-screen items-center justify-center">
                <EmptyStateMyLoads
                    // icon={}
                    colorContent="text-special"
                    bgColor="transparent"
                    title="باری برای نمایش وجود ندارد"
                    subtitle="تاکنون باری ثبت نشده است."
                    ShowButton={false}
                >


                </EmptyStateMyLoads>
                </div>
            </>
             :
             <div className="w-full flex flex-col gap-10 min-h-screen  py-10 lg:px-10 px-5">

             {/* header */}
             <div className='flex relative justify-between w-full h-auto mt-20 items-center'>
                 <p className='text-[12px] text-gray-500'>{allCargos?.length} مورد یافت شد!</p>

                 
                  
        
                         <div className="flex flex-row gap-3 w-max h-max items-center ">
                             {/*<button onClick={()=>navigate("/registerCargo")} className='lg:w-[100px] w-[80px] items-center h-[30px] text-white lg:text-[16px] text-[14px] bg-special font-light rounded-lg'>ثبت بار</button>*/}
                             <p ref={toggleRef} onClick={() => {
                                 if (openFilter) {
                                     setFilterItems(prev =>
                                         prev.map(item => ({
                                             ...item,
                                             enable: false
                                         }))
                                     );
                                 } setOpenFilter(prev => !prev)
                             }} className='text-gray-500 cursor-pointer text-[12px] flex flex-row items-center gap-1'>
                                 <CiFilter strokeWidth={2} size={15}></CiFilter>
                                 فیلتر ها
                             </p>


                             {openFilter && (
                                 <FilterModal
                                     toggleRef={toggleRef}
                                     filterItems={filterItems}
                                     setFilterItems={setFilterItems}
                                     handleSearchToggle={handleSearchToggle}
                                     onOptionClick={handleOnOptionClick}
                                     onClose={() => setOpenFilter(false)}
                                     search={search}
                                     setSearch={setSearch}
                                 />
                             )}

                         </div>
                 
             </div>

             <CargoModal cargos={allCargos}></CargoModal>

         </div>

        }
        
            <Footer></Footer>
        </>
    )
}

export default DriverCargo
